module.exports = "<wow-card-list>\r\n    <wow-shelf-bundle-list is-special=\"true\"></wow-shelf-bundle-list>\r\n</wow-card-list>\r\n<wow-inline-coaching-specials ng-if=\"inlineCoaching.shouldRun('specials')\" wow-inline-coaching></wow-inline-coaching-specials>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/specials/specials-category-center-panel-template.html
 ** module id = 1026
 ** module chunks = 1
 **/